// extracted by mini-css-extract-plugin
export var downArrow = "_80-0";
export var infoTooltipIcon = "_80-3";
export var label = "_80-1";
export var optionCard = "_80-4";
export var upArrow = "_80-2";